import { render, staticRenderFns } from "./WowInformationCard.vue?vue&type=template&id=44a0c1c3&"
import script from "./WowInformationCard.vue?vue&type=script&lang=js&"
export * from "./WowInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports